import Icon from "@mui/material/Icon";
// import MDBadge from "../../../../components/MDBadge";
import {useEffect, useMemo, useState} from "react";
import CustomService from "../../../services/custome.service";
import GHIconButton from "../../../components/GHIconButton";


export function useCitiesTable(clickItem) {

  const [rows, setRows] = useState([]);

  const columns = [
    { Header: "Name", accessor: "name", width: "20%" },
    { Header: "Province", accessor: "province", width: "20%" },
    { Header: "Country", accessor: "country", width: "20%" },
    { Header: "Actions", accessor: "action", width: "7%" },
  ];

  useEffect(() => {
    CustomService.getAllCities()
      .then((res) => {
        setRows(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return {
    columns,
    rows: rows
      ? rows.map((element) => ({
          id: element.id,
          name: element.city_name,
          province: element.province?.name || "",
          country: element.province?.country?.name || "",
          action: (
            <GHIconButton
              onClick={clickItem}
              id={element.id}
              title="Delete"
              icon="delete"
              size="small"
              color="error"
            />
          ),
        }))
      : [],
  };
}
